export default __webpack_public_path__ + "static/media/kr.1488caf0.svg";